import React from "react"
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from "globals/utils"
import { login, logout } from 'data/auth/action'
import { getAdvisorSettings } from 'data/advisor/settings/action'
import { getUserData } from 'data/user/action'
import { getRollover } from 'data/bmc/rollover/action'
import LoginForm from './form/'
import LoginMessage from './message/'
import logo from 'img/logo.svg'
import logow from 'img/logo_white.svg'
import '../style.css'
import subscription from "data/subscription/reducer"

class LoginPage extends React.Component{
  constructor(props) {
    super(props)
    props.logout(null)
    this.state = { done: false }
  }

  componentDidMount() {
    fetch(process.env.PUBLIC_URL + '/manifest.json', {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': 0
      }
    }).then((response) => response.json())
      .then((manifest) => {
        const latestBuild = new Date(manifest.version_name)
        const currentBuild = new Date(process.env.REACT_APP_BUILD)

        if (currentBuild < latestBuild) {
          console.log(`We have a new version - ${latestBuild}. Should force refresh`);
          if (caches) {
            // Service worker cache should be cleared with caches.delete()
            caches.keys().then(function(names) {
              for (let name of names) caches.delete(name);
            })
          }
          // delete browser cache and hard reload
          window.location.reload(true)
        }
      })
  }
  componentDidUpdate(prevProps) {
    if (!!this.props.isAuthenticated) {
      const {status, subscription} = this.props
      if (['expired','notrial','paymenterror'].includes(status)) {
        this.props.navigate('/suberror')
      } else if (status === 'new') {
        this.props.navigate('/wizard')
      } else if (subscription === 'signup') {
        this.props.navigate('/wizardsub')
      } else if (status === 'advisor') { 
        this.props.getAdvisorSettings().then(() => {this.props.navigate('/advisor')})
      } else if (status === 'admin') { 
        this.props.navigate('/admin')
      } else {
        this.props.getUserData().then(() => {this.props.navigate('/loading')})     
      }
    }
  }
  
  submit = data => this.props.login(data)
  
  render(){
    return(
      <div className="LoginScreen">
        <div className="LoginForm-wrapper">
          <div className="LoginForm-title">WELCOME TO</div>
          <a href={process.env.REACT_APP_SITE_URL}><img id='authLogo' src={logo} alt='logo'/></a>
          <LoginForm submit={this.submit}/>
          <LoginMessage />
        </div>
        <div className="Pinned_Logo">
          <a href={process.env.REACT_APP_SITE_URL}><img id='pinnedLogo' src={logow} alt='logo'/></a>
        </div>
      </div>
    )
  }
}

//what component needs
LoginPage.propTypes = {
  login: PropTypes.func.isRequired
}

function mapStateToProps(state) {
  return {
    isAuthenticated: !!state.auth.token, 
    status: state.auth.status, 
    subscription: state.auth.subscription
  }
}

export default withRouter(connect(mapStateToProps, { login, getUserData, getAdvisorSettings, getRollover, logout })(LoginPage))
